import { render, staticRenderFns } from "./BpmnDiagram.vue?vue&type=template&id=049aeb60&lang=html&"
import script from "./BpmnDiagram.vue?vue&type=script&lang=js&"
export * from "./BpmnDiagram.vue?vue&type=script&lang=js&"
import style0 from "./BpmnDiagram.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports